import axios from 'axios';
import { getAuthHeaders } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Save a temporary horoscope chart with a custom name
 * @param {string} chartId - Chart UUID from /horoscope response
 * @param {string} chartName - Custom name for the chart (1-100 characters)
 * @returns {Promise<Object>} - Saved chart response with details
 */
export const saveChart = async (chartId, chartName) => {
  try {
    const headers = getAuthHeaders();
    
    const response = await axios.post(
      `${API_BASE_URL}/chart/save`,
      {
        uid: chartId,
        name: chartName
      },
      { headers }
    );
    
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.detail || 'Failed to save chart');
    }
    throw new Error(error.message || 'Failed to save chart');
  }
};

/**
 * Retrieve all saved horoscope charts for the logged-in user
 * @returns {Promise<Array>} - List of saved charts with metadata
 */
export const listSavedCharts = async () => {
  try {
    const headers = getAuthHeaders();
    console.log('Fetching saved charts with headers:', headers);
    
    const response = await axios.get(
      `${API_BASE_URL}/charts`,
      { headers }
    );
    
    console.log('Saved charts response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching saved charts:', error);
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      throw new Error(error.response.data?.detail || 'Failed to retrieve saved charts');
    }
    throw new Error(error.message || 'Failed to retrieve saved charts');
  }
};

/**
 * Retrieve detailed information for a specific horoscope chart
 * @param {string} chartId - Chart UUID
 * @returns {Promise<Object>} - Complete horoscope details
 */
export const getChartDetails = async (chartId) => {
  try {
    const headers = getAuthHeaders();
    console.log('Fetching chart details for:', chartId, 'with headers:', headers);
    
    const response = await axios.get(
      `${API_BASE_URL}/chart/${chartId}`,
      { headers }
    );
    
    console.log('Chart details response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching chart details:', error);
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      throw new Error(error.response.data?.detail || 'Failed to retrieve chart');
    }
    throw new Error(error.message || 'Failed to retrieve chart');
  }
};
